import { actionTypes as actionTypes } from '../../../actions/Dialogs/CommonDialog/commonDialogActions';
import { Map} from 'immutable';

let defaultState = {
  // show: false,
  loading: false,
  activeDialog: null,
  itemToEdit: null,
  dialogData: null
};

export default function(state = Map(defaultState), action) {
  switch(action.type) {
    case actionTypes.COMMON_DIALOG_SHOW:
      return state.concat(action.payload);

    case actionTypes.COMMON_DIALOG_HIDE:
      return Map(defaultState);

    case actionTypes.COMMON_DIALOG_SET_BUSY:
      return state.set('loading', action.payload);

    case actionTypes.COMMON_DIALOG_FETCH_DIALOG_DATA_READY:
      return state.set('dialogData', action.payload)

    case actionTypes.COMMON_DIALOG_SET_VALIDATION_WARNINGS_DATA:
      return state.set('validationMessage', action.payload)
        .set('showIgnoreValidationCheckbox', action.payload.canIgnoreValidation)
        .set('hasHighSeverityWarning', action.payload.reset ? false : action.payload.hasHighSeverityWarning)
        .set('hasMediumSeverityWarning', action.payload.reset ? false : action.payload.hasMediumSeverityWarning)
        .set('hasError', !action.payload.canIgnoreValidation);

    case actionTypes.COMMON_DIALOG_HIDE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('showIgnoreValidationCheckbox', false)
        .set('hasHighSeverityWarning', false)
        .set('hasMediumSeverityWarning', false)
        .set('hasError', false)
        .set('isIgnoreValidationWarnings', false);

    case actionTypes.COMMON_DIALOG_TOGGLE_IGNORE_VALIDATION_WARNINGS_CHECKBOX:
      return state.set('isIgnoreValidationWarnings', action.payload);


    default:
      return state;
  }
}
